import { connect } from "react-redux"
import { updateDateRange } from "../../store"
import moment from "moment"
import "./Calendar.scss"
import { CalendarDropdown } from "@swipesense/calendar"

const mapStateToProps = ({ dateRange: { startDate, endDate } }) => ({
  startDate: moment(startDate),
  endDate: moment(endDate),
})

const mapDispatchToProps = dispatch => ({
  onUpdate: (startDate, endDate, selectionText) => {
    dispatch(updateDateRange(startDate, endDate))
  },
})

const CalendarDropdownWithStore = connect(
  mapStateToProps,
  mapDispatchToProps
)(CalendarDropdown)

export default CalendarDropdownWithStore
